import { locales } from '@nf/utils-common/constants';
import { createSharedPathnamesNavigation } from 'next-intl/navigation';
 
export const localePrefix = 'always'; // Default
 
export const { Link, redirect, usePathname, useRouter } =
  createSharedPathnamesNavigation({ locales, localePrefix });